import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const HomePage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="home-page">
      <div className="max-w-4xl">
        {/* Welcome Section */}
        <section className="mb-12" data-testid="welcome-section">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Welcome
          </h1>
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex-1">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                St David (University Lodge) No. 36 is a member of the Scottish University Lodge Scheme
                of the Grand Lodge of Scotland and welcomes applications from present and past students
                and staff of any Scottish university, and from gentlemen who might otherwise be precluded
                from making application to a Scottish Lodge.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Membership of the Scheme enables the Lodge to admit members from the age of 18 (normally 21)
                or who have not previously lived in Scotland for the previous three years.
              </p>
            </div>
            <div className="lg:w-64 flex-shrink-0">
              <div className="bg-gradient-to-br from-emerald-50 to-amber-50 p-4 rounded-lg border border-gray-100 shadow-sm">
                <img
                  src="/images/lodge-crest.jpg"
                  alt="Lodge St David (University Lodge) No. 36 Crest"
                  className="w-full rounded"
                  data-testid="lodge-crest"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Brotherly Love Section */}
        <section className="mb-12" data-testid="brotherly-love-section">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-gray-900 mb-6">
            Brotherly Love, Relief and Truth
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            In addition to promoting Freemasonry's principles of Brotherly Love, Relief, and Truth,
            having members with a common interest in academia, learning and personal improvement,
            enables the Lodge to provide a unique environment in which to facilitate a range of activities,
            from inter-disciplinary and inter-university intellectual interaction to simply enjoying a meal
            with colleagues and friends.
          </p>
        </section>

        {/* Origins Section */}
        <section className="mb-12" data-testid="origins-section">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-gray-900 mb-6">
            Origins of the Lodge
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            Scotland is arguably the birth place of Freemasonry and our Lodge has a long history.
            Its formation as 'Canongate from Leith' was first proposed by six members of Lodge
            Leith Kilwinning on 2 February 1738 and it was duly constituted on 2 March 1738,
            with the first meeting held on that date.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            The name was changed to 'St David' in August 1756 and University Lodge status granted
            in November 2013.
          </p>
        </section>

        {/* Key Facts Card */}
        <section data-testid="key-facts-section">
          <Card className="bg-gradient-to-br from-gray-50 to-white border-gray-100">
            <CardContent className="p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-4">Key Facts</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Founded</p>
                  <p className="text-2xl font-semibold text-emerald-700">1738</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Lodge Number</p>
                  <p className="text-2xl font-semibold text-emerald-700">No. 36</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">University Status</p>
                  <p className="text-2xl font-semibold text-emerald-700">2013</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </section>
      </div >
    </div >
  );
};

export default HomePage;
